import { Col, Form, Input, Row } from 'antd';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { FormInstance } from 'antd/es/form/Form';
import { Quiz, QuizFormValues } from '@/core/domain/crm/Quizzes/Quizzes.types';
import { FloatingFormItem } from '@/components/_common';

interface Props {
  data?: Quiz;
  form?: FormInstance<QuizFormValues>;
}

const SearchQuestionnaireForm: React.FC<Props> = ({ data, form }) => {
  useEffect(() => {
    if (!!data && !isEmpty(data) && form) {
      form.setFieldsValue({
        description: data.description,
        openingMessage: data.openingMessage,
        finalMessage: data.finalMessage,
      });
    }
  }, [data]);

  return (
    <Form form={form}>
      <Row gutter={[24, 24]}>
        <Col flex={1}>
          <FloatingFormItem
            name="description"
            label="Descrição"
            rules={[{ required: true }]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
        <Col flex={1}>
          <FloatingFormItem
            name="openingMessage"
            label="Mensagem inicial"
            rules={[{ required: true }]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
        <Col flex={1}>
          <FloatingFormItem
            name="finalMessage"
            label="Mensagem final"
            rules={[{ required: true }]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchQuestionnaireForm;
